<template>
  <div class="homeTitleBar" :style="{ background: `url(${pkValueConfig.todayBattleBgColor})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', color: pkValueConfig.todayBattleTextColor }">
      <h3>{{title}}</h3>
      <div v-if="isShowRight">
        <span>{{date}}</span> <img @click="click" src="../../../assets/images/winterGame/calendar-white.png"/>
      </div>
  </div>
</template>

<script>
export default {
  name:'homeTitleBar',
  components: {
  },
  props:{
    title:{
      type:String,
      default:'标题'
    },
    date:{
      type:String,
      default:''
    },
    isShowRight:{
      type:Boolean,
      default:false
    },
    pkValueConfig:{
      type:Object,
      default:()=>{}
    }
  },
  methods:{
    click(){
      this.$emit('selectCalendar')
    }
  }
}
</script>

<style lang="less" scoped>


.homeTitleBar {
  display: flex;
  height: 88px;
  position: relative;
  justify-content: space-between;
  h3{
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 88px;
    letter-spacing: 2px;
    margin: 0 0 0 27%;
  }
  div{
    display: flex;
    align-items: center;
    margin-right: 48px;

    span{
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 40px;
      margin-right: 8px;
    }
    img{
      width: 32px;
      height: 32px;
    }
  }
  }
</style>
